/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewBadRequestError
 */
export interface CRSFSecReviewBadRequestError {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewBadRequestError
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewBadRequestError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewBadRequestError
     */
    title: string;
}

/**
 * Check if a given object implements the CRSFSecReviewBadRequestError interface.
 */
export function instanceOfCRSFSecReviewBadRequestError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function CRSFSecReviewBadRequestErrorFromJSON(json: any): CRSFSecReviewBadRequestError {
    return CRSFSecReviewBadRequestErrorFromJSONTyped(json, false);
}

export function CRSFSecReviewBadRequestErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewBadRequestError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'status': json['status'],
        'title': json['title'],
    };
}

export function CRSFSecReviewBadRequestErrorToJSON(value?: CRSFSecReviewBadRequestError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'status': value.status,
        'title': value.title,
    };
}

